import Grid from "@mui/material/Grid";
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";
// import { useContext, useEffect, useState } from "react";
import SchwingLogo from "../../../Images/Machines/Batching plant.png";
import SchwingLogoIndia from "../../../Images/Machines/Batching plant.png";
import { useEffect, useState } from "react";
// import Context from "../../Container/MonthContext";

const tableHeadings = [
  {
    agg: "Aggregate",
    cem: "Cement",
    wat: "Water",
    wc: "WC",
    adm: "Admixture",
    sil: "Silica",
  },
];

const tableHeadings1 = [
  {
    agg: "Aggregate",
    cem: "Cement",
    wat: "Water",
    adm: "Admixture",
    sil: "Silica",
  },
];

const BatchReport = ({
  batchHeaderData,
  reportType,
  sendPlantType,
  sendplantSINo,
}) => {
  // onPdfReady
  //   const [pdfUrl, setPdfUrl] = useState(null);
  const [pdfUrlCh, setPdfUrlCh] = useState(null);

  console.log(batchHeaderData);

  async function handleGeneratePDF() {
    if (reportType === "basic") {
      const pdfDoc = await PDFDocument.create();
      const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
      const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
      const fontSize = 8.5;
      const pageWidth = 695;
      const pageHeight = 842;
      const title = "Schwing Stetter (India) Pvt. ltd.";

      const imageBytes = await fetch(SchwingLogo).then((res) =>
        res.arrayBuffer(),
      );
      const image = await pdfDoc.embedPng(imageBytes);

      const imageBytes1 = await fetch(SchwingLogoIndia).then((res) =>
        res.arrayBuffer(),
      );
      const image1 = await pdfDoc.embedPng(imageBytes1);

      let logo;

      try {
        const imageUrl = "https://placehold.co/600x400/png";
        if (!imageUrl) throw new Error("No image URL available");

        const imageBytes = await fetch(imageUrl).then((res) =>
          res.arrayBuffer(),
        );

        if (imageUrl.includes("png")) {
          logo = await pdfDoc.embedPng(imageBytes);
        } else if (imageUrl.includes("jpeg") || imageUrl.includes("jpg")) {
          logo = await pdfDoc.embedJpg(imageBytes);
        } else {
          throw new Error(
            "Unsupported image format. Only PNG and JPG are allowed.",
          );
        }

        batchHeaderData.forEach((data) => {
          let page = pdfDoc.addPage([pageWidth, pageHeight]);

          if (sessionStorage.getItem("leftimage") === "1") {
            page.drawImage(image1, {
              x: 20,
              y: 790,
              width: 100,
              height: 40,
            });
          } else {
            page.drawImage(image, {
              x: 20,
              y: 800,
              width: 100,
              height: 30,
            });
          }

          //   if (sessionStorage.getItem("footer") !== "") {
          //     const maxWidth = page.getWidth();
          //     const footerText = sessionStorage.getItem("footer");
          //     const lineHeight = 12;

          //     const yPos = 40;

          //     // Draw footer line
          //     page.drawLine({
          //       start: { x: 10, y: yPos + 15 },
          //       end: { x: maxWidth - 10, y: yPos + 15 },
          //       thickness: 1,
          //       color: rgb(0, 0, 0),
          //     });

          //     // Draw footer text
          //     page.drawText(footerText, {
          //       x: 30,
          //       y: yPos,
          //       size: 10,
          //       font: boldFont,
          //       maxWidth: maxWidth - 60,
          //       lineHeight: lineHeight,
          //     });
          //   }

          //   if (sessionStorage.getItem("logo") === "1" && logo) {
          //     const imgDims = logo.scale(1); // gets native width & height in points

          //     const targetWidth = 60;
          //     const aspectRatio = imgDims.height / imgDims.width;
          //     const targetHeight = targetWidth * aspectRatio;

          //     page.drawImage(logo, {
          //       x: 600,
          //       y: 780,
          //       width: targetWidth,
          //       height: targetHeight,
          //     });
          //   }

          const text = sessionStorage.getItem("comp_name");
          const textWidth = boldFont.widthOfTextAtSize(text, 15);
          const centerX = (pageWidth - textWidth) / 2;

          page.drawText(text, {
            x: centerX,
            y: 820,
            size: 15,
            font: boldFont,
          });

          page.drawText("BATCH SHEET REPORT", {
            x: 255,
            y: 800,
            size: 15,
            font: boldFont,
          });
          page.drawText("Plant Type :", {
            x: 90,
            y: 770,
            size: 15,
            font: boldFont,
          });
          page.drawText(sendPlantType || "N/A", {
            x: 180,
            y: 770,
            size: 13,
            font,
          });
          page.drawText("Plant Sl.No :", {
            x: 450,
            y: 770,
            size: 15,
            font: boldFont,
          });

          page.drawText(sendplantSINo || "N/A", {
            x: 550,
            y: 770,
            size: 13,
            font,
          });

          page.drawLine({
            start: { x: 30, y: 765 }, // slightly below the text
            end: { x: pageWidth - 25, y: 765 },
            thickness: 1,
            color: rgb(0, 0, 0), // black color
          });
          page.drawText("Batch Number :", {
            x: 30,
            y: 750,
            size: 13,
            font: boldFont,
          });

          page.drawText(String(data?.b_no) || "N/A", {
            x: 130,
            y: 750,
            size: 11,
            font,
          });

          page.drawText("Recipe Name :", {
            x: 250,
            y: 750,
            size: 13,
            font: boldFont,
          });

          const recpText = data?.recp_n || "N/A";
          const maxLineLength = 20;
          const startX = 345;
          let startY = 750;

          // Split text into chunks of 20 characters
          const wrappedLines =
            recpText.match(new RegExp(`.{1,${maxLineLength}}`, "g")) || [];

          wrappedLines.forEach((line, index) => {
            page.drawText(line, {
              x: startX,
              y: startY - index * 10, // Adjust line spacing here
              size: 11,
              font,
            });
          });

          page.drawText("Mixer Capacity :", {
            x: 500,
            y: 750,
            size: 13,
            font: boldFont,
          });
          page.drawText(String(data?.m_cap) || "N/A", {
            x: 605,
            y: 750,
            size: 11,
            font,
          });
          page.drawText("Batch Date      :", {
            x: 30,
            y: 730,
            size: 13,
            font: boldFont,
          });
          page.drawText(data?.date || "N/A", {
            x: 130,
            y: 730,
            size: 11,
            font,
          });
          page.drawText("Recipe Code  :", {
            x: 250,
            y: 730,
            size: 13,
            font: boldFont,
          });
          page.drawText(data?.recp_id || "N/A", {
            x: 345,
            y: 730,
            size: 11,
            font,
          });
          page.drawText("Batch Size        :", {
            x: 500,
            y: 730,
            size: 13,
            font: boldFont,
          });
          page.drawText(String(data?.size) || "N/A", {
            x: 605,
            y: 730,
            size: 11,
            font,
          });
          page.drawText("Batch St Time :", {
            x: 30,
            y: 710,
            size: 13,
            font: boldFont,
          });
          page.drawText(data?.b_st || "N/A", {
            x: 130,
            y: 710,
            size: 11,
            font,
          });
          page.drawText("Truck No        :", {
            x: 250,
            y: 710,
            size: 13,
            font: boldFont,
          });
          page.drawText(data?.trk_id || "N/A", {
            x: 345,
            y: 710,
            size: 11,
            font,
          });
          page.drawText("Prod Qty           :", {
            x: 500,
            y: 710,
            size: 13,
            font: boldFont,
          });
          page.drawText(String(data?.qty) || "N/A", {
            x: 605,
            y: 710,
            size: 11,
            font,
          });
          page.drawText("Batch Et Time :", {
            x: 30,
            y: 690,
            size: 13,
            font: boldFont,
          });
          page.drawText(data?.b_et || "N/A", {
            x: 130,
            y: 690,
            size: 11,
            font,
          });
          page.drawText("Truck Driver  :", {
            x: 250,
            y: 690,
            size: 13,
            font: boldFont,
          });

          page.drawText(data?.driver || "N/A", {
            x: 345,
            y: 690,
            size: 11,
            font,
          });

          page.drawText("Order No           :", {
            x: 500,
            y: 690,
            size: 13,
            font: boldFont,
          });
          page.drawText(data?.o_id || "N/A", {
            x: 605,
            y: 690,
            size: 11,
            font,
          });
          page.drawText("Customer        :", {
            x: 30,
            y: 670,
            size: 13,
            font: boldFont,
          });
          page.drawText(data?.c_id || "N/A", {
            x: 130,
            y: 670,
            size: 11,
            font,
          });

          page.drawText("Adj/Manual Qty  :", {
            x: 250,
            y: 670,
            size: 13,
            font: boldFont,
          });
          page.drawText(String(data?.p_adj) || "N/A", {
            x: 360,
            y: 670,
            size: 11,
            font,
          });

          page.drawText("Order Qty          :", {
            x: 500,
            y: 670,
            size: 13,
            font: boldFont,
          });

          page.drawText(String(data?.o_qty) || "N/A", {
            x: 605,
            y: 670,
            size: 11,
            font,
          });

          page.drawText("Site                  :", {
            x: 30,
            y: 650,
            size: 13,
            font: boldFont,
          });
          page.drawText(String(data?.site) || "N/A", {
            x: 130,
            y: 650,
            size: 11,
            font,
          });
          page.drawText("With This Load :", {
            x: 500,
            y: 650,
            size: 13,
            font: boldFont,
          });

          page.drawText(String(data?.l_qty) || "N/A", {
            x: 605,
            y: 650,
            size: 11,
            font,
          });

          page.drawText("Aggregate", {
            x: 90,
            y: 620,
            size: 13,
            font: boldFont,
          });
          // Draw a horizontal line below the text at y = 615 (a bit below the text)
          page.drawLine({
            start: { x: 30, y: 615 },
            end: { x: 215, y: 615 },
            thickness: 1, // You can adjust the line thickness
            color: rgb(0, 0, 0), // Black color
          });
          page.drawText("Cement", {
            x: 280,
            y: 620,
            size: 13,
            font: boldFont,
          });
          page.drawLine({
            start: { x: 220, y: 615 },
            end: { x: 370, y: 615 },
            thickness: 1, // You can adjust the line thickness
            color: rgb(0, 0, 0), // Black color
          });
          page.drawText("Water", {
            x: 410,
            y: 620,
            size: 13,
            font: boldFont,
          });

          page.drawLine({
            start: { x: 375, y: 615 },
            end: { x: 475, y: 615 },
            thickness: 1, // You can adjust the line thickness
            color: rgb(0, 0, 0), // Black color
          });
          page.drawText("Admixture", {
            x: 520,
            y: 620,
            size: 13,
            font: boldFont,
          });
          page.drawLine({
            start: { x: 480, y: 615 },
            end: { x: 620, y: 615 },
            thickness: 1, // You can adjust the line thickness
            color: rgb(0, 0, 0), // Black color
          });
          page.drawText("Silica", {
            x: 630,
            y: 620,
            size: 13,
            font: boldFont,
          });
          page.drawLine({
            start: { x: 625, y: 615 },
            end: { x: 675, y: 615 },
            thickness: 1, // You can adjust the line thickness
            color: rgb(0, 0, 0), // Black color
          });

          const positions = [
            30, 60, 90, 120, 150, 180, 220, 250, 280, 310, 340, 380, 410, 445,
            480, 515, 550, 590, 640,
          ];

          const yStart = 600;
          const lineHeight = 12;
          const maxCharsPerLine = 3;

          let maxWrapLines = 0; // Track max lines used in any wrapped column

          // Draw `mat` with wrapping and track max wrap height
          for (let i = 0; i < data.mat.length && i < positions.length; i++) {
            const item = data.mat[i] || "";
            const x = positions[i];

            const lines = item
              ? item.match(new RegExp(`.{1,${maxCharsPerLine}}`, "g"))
              : [];

            if (lines.length > maxWrapLines) maxWrapLines = lines.length;

            lines.forEach((textLine, j) => {
              const y = yStart - j * lineHeight;
              page.drawText(textLine, {
                x,
                y,
                size: 11,
                font: boldFont,
              });
            });
          }

          // Compute y position for `recp` just below the last `mat` line
          const recpY = yStart - maxWrapLines * lineHeight - 5; // Add padding

          // Draw `recp` in one line per value
          for (let i = 0; i < data.recp.length && i < positions.length; i++) {
            const recpItem = data.recp[i] || "";
            const x = positions[i];

            page.drawText(recpItem.toString(), {
              x,
              y: recpY,
              size: 11,
              font,
            });
          }

          // Compute y position for `tar` just below the last `mat` line
          const tarY = yStart - maxWrapLines * lineHeight - 20; // Add padding

          // Draw `tar` in one line per value
          for (let i = 0; i < data.tar.length && i < positions.length; i++) {
            const tarItem = data.tar[i] || "";
            const x = positions[i];

            page.drawText(tarItem.toString(), {
              x,
              y: tarY,
              size: 11,
              font,
            });
          }

          // Compute y position for `moi` just below the last `mat` line
          const moiY = yStart - maxWrapLines * lineHeight - 35; // Add padding

          // Draw `moi` in one line per value
          for (let i = 0; i < data.moi.length && i < positions.length; i++) {
            const moiItem = data.moi[i] || "";
            const x = positions[i];

            page.drawText(moiItem.toString(), {
              x,
              y: moiY,
              size: 11,
              font,
            });
          }

          // Compute y position for `abs` just below the last `mat` line
          const absY = yStart - maxWrapLines * lineHeight - 50; // Add padding

          // Draw `abs` in one line per value
          for (let i = 0; i < data.abs.length && i < positions.length; i++) {
            const absItem = data.abs[i] || "";
            const x = positions[i];

            page.drawText(absItem.toString(), {
              x,
              y: absY,
              size: 11,
              font,
            });
          }

          page.drawText("Mass of Recipe Targets in kg :", {
            x: 420,
            y: absY,
            size: 13,
            font: boldFont,
          });
          let totalSum = 0;

          for (let i = 0; i < data.recp.length; i++) {
            const recpItem = data.recp[i];

            if (typeof recpItem === "string" && recpItem.includes("+")) {
              const parts = recpItem
                .split("+")
                .map((p) => parseFloat(p.trim()));
              if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
                totalSum += parts[0] + parts[1];
              }
            } else {
              const num = parseFloat(recpItem);
              if (!isNaN(num)) {
                totalSum += num;
              }
            }
          }

          page.drawText(totalSum.toString(), {
            x: 620,
            y: absY, // Adjust based on spacing
            size: 12,
            font: boldFont,
          });
          page.drawText("Actual Values In kg", {
            x: 30,
            y: absY - 20,
            size: 13,
            font: boldFont,
          });
          page.drawLine({
            start: { x: 30, y: absY - 25 }, // slightly below the text
            end: { x: pageWidth - 25, y: absY - 25 },
            thickness: 1,
            color: rgb(0, 0, 0), // black color
          });
          const actStartY = absY - 40;
          const actLineSpacing = 15;

          data.act.forEach((row, rowIndex) => {
            const y = actStartY - rowIndex * actLineSpacing;

            row.atwt.forEach((value, i) => {
              if (i === row.atwt.length - 1) return; // Skip the last index

              const x = positions[i];
              page.drawText(value.toString(), {
                x,
                y,
                size: 11,
                font,
              });
            });
          });
          // 👉 Add "Total Set Weight in Kg" after last act row
          const totalY = actStartY - data.act.length * actLineSpacing - 5; // small gap after last row

          page.drawText("Total Set Weight in Kg", {
            x: 30,
            y: totalY,
            size: 13,
            font: boldFont,
          });
          page.drawLine({
            start: { x: 30, y: totalY - 5 }, // slightly below the text
            end: { x: pageWidth - 25, y: totalY - 5 },
            thickness: 1,
            color: rgb(0, 0, 0), // black color
          });
          // Compute y position for `setWeight` just below the last `actual weight` line
          const setY = totalY - 20; // Add padding

          // Draw `setWeight` in one line per value
          for (let i = 0; i < data.t_tar.length && i < positions.length; i++) {
            const setItem = data.t_tar[i] || "";
            const x = positions[i];

            page.drawText(setItem.toString(), {
              x,
              y: setY,
              size: 11,
              font,
            });
          }

          page.drawText("Mass of Total Set Weight in kg :", {
            x: 420,
            y: totalY - 40,
            size: 13,
            font: boldFont,
          });
          let totalSetSum = 0;

          for (let i = 0; i < data.t_tar.length; i++) {
            const setItem = data.t_tar[i];

            if (typeof setItem === "string" && setItem.includes("+")) {
              const parts = setItem.split("+").map((p) => parseFloat(p.trim()));
              if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
                totalSetSum += parts[0] + parts[1];
              }
            } else {
              const num = parseFloat(setItem);
              if (!isNaN(num)) {
                totalSetSum += num;
              }
            }
          }
          page.drawText(totalSetSum.toString(), {
            x: 620,
            y: totalY - 40, // Adjust based on spacing
            size: 12,
            font: boldFont,
          });
          page.drawText("Total Actual Weight in Kg", {
            x: 30,
            y: totalY - 55,
            size: 13,
            font: boldFont,
          });
          page.drawLine({
            start: { x: 30, y: totalY - 60 }, // slightly below the text
            end: { x: pageWidth - 25, y: totalY - 60 },
            thickness: 1,
            color: rgb(0, 0, 0), // black color
          });

          // Compute y position for `setWeight` just below the last `actual weight` line
          const actY = totalY - 75; // Add padding

          // Draw `setWeight` in one line per value
          for (let i = 0; i < data.t_act.length && i < positions.length; i++) {
            const setItem = data.t_act[i] || "";
            const x = positions[i];

            page.drawText(setItem.toString(), {
              x,
              y: actY,
              size: 11,
              font,
            });
          }
          page.drawText("Mass of Total Actual Weight in kg :", {
            x: 410,
            y: totalY - 95,
            size: 13,
            font: boldFont,
          });
          let totalActSum = 0;

          for (let i = 0; i < data.t_act.length; i++) {
            const actItem = data.t_act[i];

            if (typeof actItem === "string" && actItem.includes("+")) {
              const parts = actItem.split("+").map((p) => parseFloat(p.trim()));
              if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
                totalActSum += parts[0] + parts[1];
              }
            } else {
              const num = parseFloat(actItem);
              if (!isNaN(num)) {
                totalActSum += num;
              }
            }
          }

          page.drawText(totalActSum.toString(), {
            x: 630,
            y: totalY - 95, // Adjust based on spacing
            size: 12,
            font: boldFont,
          });

          page.drawText("Difference in Percentage", {
            x: 30,
            y: totalY - 110,
            size: 13,
            font: boldFont,
          });
          page.drawLine({
            start: { x: 30, y: totalY - 115 }, // slightly below the text
            end: { x: pageWidth - 25, y: totalY - 115 },
            thickness: 1,
            color: rgb(0, 0, 0), // black color
          });

          // Compute y position for `setWeight` just below the last `actual weight` line
          const diffY = totalY - 130; // Add padding

          // Draw `setWeight` in one line per value
          for (let i = 0; i < data.diff.length && i < positions.length; i++) {
            const diffItem = data.diff[i].toFixed(1) || "";
            const x = positions[i];

            page.drawText(diffItem, {
              x,
              y: diffY,
              size: 11,
              font,
            });
          }

          page.drawText("Total Mass Difference In Percentage :", {
            x: 390,
            y: totalY - 150,
            size: 13,
            font: boldFont,
          });
          let totalDiffSum = 0;

          for (let i = 0; i < data.diff.length; i++) {
            const diffItem = data.diff[i];

            if (typeof diffItem === "string" && diffItem.includes("+")) {
              const parts = diffItem
                .split("+")
                .map((p) => parseFloat(p.trim()));
              if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
                totalDiffSum += parts[0] + parts[1];
              }
            } else {
              const num = parseFloat(diffItem);
              if (!isNaN(num)) {
                totalDiffSum += num;
              }
            }
          }
          page.drawText(totalDiffSum.toString(), {
            x: 630,
            y: totalY - 150, // Adjust based on spacing
            size: 12,
            font: boldFont,
          });
        });

        const pdfBytes = await pdfDoc.save();
        setPdfUrlCh(
          URL.createObjectURL(
            new Blob([pdfBytes], { type: "application/pdf" }),
          ),
        );
      } catch (error) {
        console.error("Error generating PDF:", error);
      }
    } else {
      const pdfDoc = await PDFDocument.create();
      const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
      const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
      const fontSize = 8.5;
      const pageWidth = 695;
      const pageHeight = 842;
      const title = "Schwing Stetter (India) Pvt. ltd.";

      const imageBytes = await fetch(SchwingLogo).then((res) =>
        res.arrayBuffer(),
      );
      const image = await pdfDoc.embedPng(imageBytes);

      const imageBytes1 = await fetch(SchwingLogoIndia).then((res) =>
        res.arrayBuffer(),
      );
      const image1 = await pdfDoc.embedPng(imageBytes1);

      let logo;
      try {
        const imageUrl = sessionStorage.getItem("logoImageUrl"); // <-- get from sessionStorage
        if (!imageUrl) throw new Error("No image URL available");

        const imageBytes = await fetch(imageUrl).then((res) =>
          res.arrayBuffer(),
        );

        if (imageUrl.includes("png")) {
          logo = await pdfDoc.embedPng(imageBytes);
        } else if (imageUrl.includes("jpeg") || imageUrl.includes("jpg")) {
          logo = await pdfDoc.embedJpg(imageBytes);
        } else {
          throw new Error(
            "Unsupported image format. Only PNG and JPG are allowed.",
          );
        }

        batchHeaderData.forEach((data) => {
          let page = pdfDoc.addPage([pageWidth, pageHeight]);
          if (sessionStorage.getItem("leftimage") === "1") {
            page.drawImage(image1, {
              x: 20,
              y: 790,
              width: 100,
              height: 40,
            });
          } else {
            page.drawImage(image, {
              x: 20,
              y: 800,
              width: 100,
              height: 30,
            });
          }

          if (sessionStorage.getItem("footer") !== "") {
            const maxWidth = page.getWidth();
            const footerText = sessionStorage.getItem("footer");
            const lineHeight = 12;

            const yPos = 40;

            // Draw footer line
            page.drawLine({
              start: { x: 10, y: yPos + 15 },
              end: { x: maxWidth - 10, y: yPos + 15 },
              thickness: 1,
              color: rgb(0, 0, 0),
            });

            // Draw footer text
            page.drawText(footerText, {
              x: 30,
              y: yPos,
              size: 10,
              font: boldFont,
              maxWidth: maxWidth - 60,
              lineHeight: lineHeight,
            });
          }

          if (sessionStorage.getItem("logo") === "1" && logo) {
            const imgDims = logo.scale(1); // gets native width & height in points

            const targetWidth = 60;
            const aspectRatio = imgDims.height / imgDims.width;
            const targetHeight = targetWidth * aspectRatio;

            page.drawImage(logo, {
              x: 600,
              y: 780,
              width: targetWidth,
              height: targetHeight,
            });
          }
          const text = sessionStorage.getItem("comp_name");
          const textWidth = boldFont.widthOfTextAtSize(text, 15);
          const centerX = (pageWidth - textWidth) / 2;

          page.drawText(text, {
            x: centerX,
            y: 820,
            size: 15,
            font: boldFont,
          });

          page.drawText("BATCH SHEET REPORT", {
            x: 255,
            y: 800,
            size: 15,
            font: boldFont,
          });
          page.drawText("Plant Type :", {
            x: 90,
            y: 770,
            size: 15,
            font: boldFont,
          });
          page.drawText(data?.p_t || "N/A", {
            x: 180,
            y: 770,
            size: 13,
            font,
          });
          page.drawText("Plant Sl.No :", {
            x: 450,
            y: 770,
            size: 15,
            font: boldFont,
          });
          page.drawText(data?.p_sl || "N/A", {
            x: 550,
            y: 770,
            size: 13,
            font,
          });
          page.drawLine({
            start: { x: 30, y: 765 }, // slightly below the text
            end: { x: pageWidth - 25, y: 765 },
            thickness: 1,
            color: rgb(0, 0, 0), // black color
          });
          page.drawText("Batch Number :", {
            x: 30,
            y: 750,
            size: 13,
            font: boldFont,
          });
          page.drawText(data?.b_no || "N/A", {
            x: 130,
            y: 750,
            size: 11,
            font,
          });
          page.drawText("Recipe Name :", {
            x: 250,
            y: 750,
            size: 13,
            font: boldFont,
          });
          const recpText = data?.recp_n || "N/A";
          const maxLineLength = 20;
          const startX = 345;
          let startY = 750;

          // Split text into chunks of 20 characters
          const wrappedLines =
            recpText.match(new RegExp(`.{1,${maxLineLength}}`, "g")) || [];

          wrappedLines.forEach((line, index) => {
            page.drawText(line, {
              x: startX,
              y: startY - index * 10, // Adjust line spacing here
              size: 11,
              font,
            });
          });

          page.drawText("Mixer Capacity :", {
            x: 500,
            y: 750,
            size: 13,
            font: boldFont,
          });

          page.drawText(String(data?.m_cap) || "N/A", {
            x: 605,
            y: 750,
            size: 11,
            font,
          });
          page.drawText("Batch Date      :", {
            x: 30,
            y: 730,
            size: 13,
            font: boldFont,
          });
          page.drawText(data?.date || "N/A", {
            x: 130,
            y: 730,
            size: 11,
            font,
          });
          page.drawText("Recipe Code  :", {
            x: 250,
            y: 730,
            size: 13,
            font: boldFont,
          });
          page.drawText(data?.recp_id || "N/A", {
            x: 345,
            y: 730,
            size: 11,
            font,
          });
          page.drawText("Batch Size        :", {
            x: 500,
            y: 730,
            size: 13,
            font: boldFont,
          });
          page.drawText(data?.size || "N/A", {
            x: 605,
            y: 730,
            size: 11,
            font,
          });
          page.drawText("Batch St Time :", {
            x: 30,
            y: 710,
            size: 13,
            font: boldFont,
          });
          page.drawText(data?.b_st || "N/A", {
            x: 130,
            y: 710,
            size: 11,
            font,
          });
          page.drawText("Truck No        :", {
            x: 250,
            y: 710,
            size: 13,
            font: boldFont,
          });
          page.drawText(data?.trk_id || "N/A", {
            x: 345,
            y: 710,
            size: 11,
            font,
          });
          page.drawText("Prod Qty           :", {
            x: 500,
            y: 710,
            size: 13,
            font: boldFont,
          });
          page.drawText(String(data?.qty) || "N/A", {
            x: 605,
            y: 710,
            size: 11,
            font,
          });
          page.drawText("Batch Et Time :", {
            x: 30,
            y: 690,
            size: 13,
            font: boldFont,
          });
          page.drawText(data?.b_et || "N/A", {
            x: 130,
            y: 690,
            size: 11,
            font,
          });
          page.drawText("Truck Driver  :", {
            x: 250,
            y: 690,
            size: 13,
            font: boldFont,
          });
          page.drawText(data?.driver || "N/A", {
            x: 345,
            y: 690,
            size: 11,
            font,
          });
          page.drawText("Order No           :", {
            x: 500,
            y: 690,
            size: 13,
            font: boldFont,
          });
          page.drawText(data?.o_id || "N/A", {
            x: 605,
            y: 690,
            size: 11,
            font,
          });
          page.drawText("Customer        :", {
            x: 30,
            y: 670,
            size: 13,
            font: boldFont,
          });
          page.drawText(data?.c_id || "N/A", {
            x: 130,
            y: 670,
            size: 11,
            font,
          });
          page.drawText("Adj/Manual Qty  :", {
            x: 250,
            y: 670,
            size: 13,
            font: boldFont,
          });
          page.drawText(String(data?.p_adj) || "N/A", {
            x: 360,
            y: 670,
            size: 11,
            font,
          });
          page.drawText("Order Qty          :", {
            x: 500,
            y: 670,
            size: 13,
            font: boldFont,
          });
          page.drawText(String(data?.o_qty) || "N/A", {
            x: 605,
            y: 670,
            size: 11,
            font,
          });
          page.drawText("Site                  :", {
            x: 30,
            y: 650,
            size: 13,
            font: boldFont,
          });
          page.drawText(data?.site || "N/A", {
            x: 130,
            y: 650,
            size: 11,
            font,
          });
          page.drawText("With This Load :", {
            x: 500,
            y: 650,
            size: 13,
            font: boldFont,
          });
          page.drawText(String(data?.l_qty) || "N/A", {
            x: 605,
            y: 650,
            size: 11,
            font,
          });
          page.drawText("Aggregate", {
            x: 90,
            y: 620,
            size: 13,
            font: boldFont,
          });
          // Draw a horizontal line below the text at y = 615 (a bit below the text)
          page.drawLine({
            start: { x: 30, y: 615 },
            end: { x: 215, y: 615 },
            thickness: 1, // You can adjust the line thickness
            color: rgb(0, 0, 0), // Black color
          });
          page.drawText("Cement", {
            x: 280,
            y: 620,
            size: 13,
            font: boldFont,
          });
          page.drawLine({
            start: { x: 220, y: 615 },
            end: { x: 370, y: 615 },
            thickness: 1, // You can adjust the line thickness
            color: rgb(0, 0, 0), // Black color
          });
          page.drawText("Water", {
            x: 410,
            y: 620,
            size: 13,
            font: boldFont,
          });
          page.drawLine({
            start: { x: 375, y: 615 },
            end: { x: 475, y: 615 },
            thickness: 1, // You can adjust the line thickness
            color: rgb(0, 0, 0), // Black color
          });
          page.drawText("Admixture", {
            x: 520,
            y: 620,
            size: 13,
            font: boldFont,
          });
          page.drawLine({
            start: { x: 480, y: 615 },
            end: { x: 620, y: 615 },
            thickness: 1, // You can adjust the line thickness
            color: rgb(0, 0, 0), // Black color
          });
          page.drawText("Silica", {
            x: 630,
            y: 620,
            size: 13,
            font: boldFont,
          });
          page.drawLine({
            start: { x: 625, y: 615 },
            end: { x: 675, y: 615 },
            thickness: 1, // You can adjust the line thickness
            color: rgb(0, 0, 0), // Black color
          });
          const positions = [
            30, 60, 90, 120, 150, 180, 220, 250, 280, 310, 340, 380, 410, 445,
            480, 515, 550, 590, 640,
          ];
          const yStart = 600;
          const lineHeight = 12;
          const maxCharsPerLine = 3;

          let maxWrapLines = 0; // Track max lines used in any wrapped column

          // Draw `mat` with wrapping and track max wrap height
          for (let i = 0; i < data.mat.length && i < positions.length; i++) {
            const item = data.mat[i] || "";
            const x = positions[i];

            const lines = item
              ? item.match(new RegExp(`.{1,${maxCharsPerLine}}`, "g"))
              : [];

            if (lines.length > maxWrapLines) maxWrapLines = lines.length;

            lines.forEach((textLine, j) => {
              const y = yStart - j * lineHeight;
              page.drawText(textLine, {
                x,
                y,
                size: 11,
                font: boldFont,
              });
            });
          }
          // Compute y position for `recp` just below the last `mat` line
          const recpY = yStart - maxWrapLines * lineHeight - 5; // Add padding

          // Draw `recp` in one line per value
          for (let i = 0; i < data.recp.length && i < positions.length; i++) {
            const recpItem = data.recp[i] || "";
            const x = positions[i];

            page.drawText(recpItem.toString(), {
              x,
              y: recpY,
              size: 11,
              font,
            });
          }
          page.drawText("Mass of Recipe Targets in kg :", {
            x: 420,
            y: recpY - 20,
            size: 13,
            font: boldFont,
          });
          let totalSum = 0;

          for (let i = 0; i < data.recp.length; i++) {
            const recpItem = data.recp[i];

            if (typeof recpItem === "string" && recpItem.includes("+")) {
              const parts = recpItem
                .split("+")
                .map((p) => parseFloat(p.trim()));
              if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
                totalSum += parts[0] + parts[1];
              }
            } else {
              const num = parseFloat(recpItem);
              if (!isNaN(num)) {
                totalSum += num;
              }
            }
          }
          page.drawText(totalSum.toString(), {
            x: 620,
            y: recpY - 20, // Adjust based on spacing
            size: 12,
            font: boldFont,
          });
          page.drawText("Actual Values in Kg", {
            x: 30,
            y: recpY - 30,
            size: 13,
            font: boldFont,
          });
          page.drawLine({
            start: { x: 30, y: recpY - 35 }, // slightly below the text
            end: { x: pageWidth - 25, y: recpY - 35 },
            thickness: 1,
            color: rgb(0, 0, 0), // black color
          });
          const drawActData = (
            data,
            page,
            startY,
            lineHeight,
            positions,
            font,
            boldFont,
            pdfDoc,
          ) => {
            const bottomMargin = 60;
            let y = startY;
            let currentPage = page;

            data.act.forEach((row, rowIndex) => {
              if (y < bottomMargin + 3 * lineHeight + 10) {
                currentPage = pdfDoc.addPage([pageWidth, pageHeight]);
                y = 800;
              }

              row.atwt.forEach((value, i) => {
                const x = positions[i];
                currentPage.drawText(value.toString(), {
                  x,
                  y,
                  size: 11,
                  font,
                });
              });
              y -= lineHeight;

              row.stwt?.forEach((value, i) => {
                const x = positions[i];
                currentPage.drawText(value.toString(), {
                  x,
                  y,
                  size: 11,
                  font,
                });
              });
              y -= lineHeight;

              row.moi?.forEach((value, i) => {
                const x = positions[i];
                currentPage.drawText(value.toString(), {
                  x,
                  y,
                  size: 11,
                  font,
                });
              });
              y -= lineHeight;

              currentPage.drawLine({
                start: { x: 30, y: y + 5 },
                end: { x: pageWidth - 25, y: y + 5 },
                thickness: 1,
                color: rgb(0, 0, 0),
              });

              y -= 10;
            });

            return { finalY: y, lastPage: currentPage };
          };

          const { finalY, lastPage } = drawActData(
            data,
            page,
            recpY - 50,
            15,
            positions,
            font,
            boldFont,
            pdfDoc, // ✅ correct 8th argument now
          );
          let labelPage = lastPage;
          let labelY = finalY;

          // Estimate total vertical space needed for the summary
          const summaryBlockHeight = 140;

          if (labelY < summaryBlockHeight + 60) {
            labelPage = pdfDoc.addPage([pageWidth, pageHeight]);
            labelY = 800;
          }

          if (sessionStorage.getItem("footer") !== "") {
            const maxWidth = page.getWidth();
            const footerText = sessionStorage.getItem("footer");
            const lineHeight = 12;

            const yPos = 40;

            // Draw footer line
            labelPage.drawLine({
              start: { x: 10, y: yPos + 15 },
              end: { x: maxWidth - 10, y: yPos + 15 },
              thickness: 1,
              color: rgb(0, 0, 0),
            });

            // Draw footer text
            labelPage.drawText(footerText, {
              x: 30,
              y: yPos,
              size: 10,
              font: boldFont,
              maxWidth: maxWidth - 60,
              lineHeight: lineHeight,
            });
          }

          // Total Set Weight
          labelPage.drawText("Total Set Weight in Kg", {
            x: 30,
            y: labelY,
            size: 13,
            font: boldFont,
          });
          labelPage.drawLine({
            start: { x: 30, y: labelY - 5 },
            end: { x: pageWidth - 25, y: labelY - 5 },
            thickness: 1,
            color: rgb(0, 0, 0),
          });

          const setY = labelY - 20;

          for (let i = 0; i < data.t_tar.length && i < positions.length; i++) {
            const setItem = data.t_tar[i] || "";
            const x = positions[i];

            labelPage.drawText(setItem.toString(), {
              x,
              y: setY,
              size: 11,
              font,
            });
          }

          labelPage.drawText("Mass of Total Set Weight in kg :", {
            x: 420,
            y: setY - 20,
            size: 13,
            font: boldFont,
          });

          let totalSetSum = 0;
          for (let i = 0; i < data.t_tar.length; i++) {
            const setItem = data.t_tar[i];
            if (typeof setItem === "string" && setItem.includes("+")) {
              const parts = setItem.split("+").map((p) => parseFloat(p.trim()));
              if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
                totalSetSum += parts[0] + parts[1];
              }
            } else {
              const num = parseFloat(setItem);
              if (!isNaN(num)) totalSetSum += num;
            }
          }

          labelPage.drawText(totalSetSum.toString(), {
            x: 630,
            y: setY - 20,
            size: 12,
            font: boldFont,
          });

          // Total Actual Weight
          const actY = setY - 30;
          labelPage.drawText("Total Actual Weight in Kg", {
            x: 30,
            y: actY,
            size: 13,
            font: boldFont,
          });
          labelPage.drawLine({
            start: { x: 30, y: actY - 5 },
            end: { x: pageWidth - 25, y: actY - 5 },
            thickness: 1,
            color: rgb(0, 0, 0),
          });

          const actRowY = actY - 20;

          for (let i = 0; i < data.t_act.length && i < positions.length; i++) {
            const actItem = data.t_act[i] || "";
            const x = positions[i];

            labelPage.drawText(actItem.toString(), {
              x,
              y: actRowY,
              size: 11,
              font,
            });
          }

          labelPage.drawText("Mass of Total Actual Weight in kg :", {
            x: 410,
            y: actRowY - 20,
            size: 13,
            font: boldFont,
          });

          let totalActSum = 0;
          for (let i = 0; i < data.t_act.length; i++) {
            const actItem = data.t_act[i];
            if (typeof actItem === "string" && actItem.includes("+")) {
              const parts = actItem.split("+").map((p) => parseFloat(p.trim()));
              if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
                totalActSum += parts[0] + parts[1];
              }
            } else {
              const num = parseFloat(actItem);
              if (!isNaN(num)) totalActSum += num;
            }
          }

          labelPage.drawText(totalActSum.toString(), {
            x: 630,
            y: actRowY - 20,
            size: 12,
            font: boldFont,
          });

          // Difference Percentage
          const diffY = actRowY - 30;
          labelPage.drawText("Difference in Percentage", {
            x: 30,
            y: diffY,
            size: 13,
            font: boldFont,
          });
          labelPage.drawLine({
            start: { x: 30, y: diffY - 5 },
            end: { x: pageWidth - 25, y: diffY - 5 },
            thickness: 1,
            color: rgb(0, 0, 0),
          });

          const diffRowY = diffY - 20;

          for (let i = 0; i < data.diff.length && i < positions.length; i++) {
            const diffItem = data.diff[i];
            const x = positions[i];
            labelPage.drawText(diffItem.toFixed(1), {
              x,
              y: diffRowY,
              size: 11,
              font,
            });
          }

          labelPage.drawText("Total Mass Difference In Percentage :", {
            x: 390,
            y: diffRowY - 20,
            size: 13,
            font: boldFont,
          });

          let totalDiffSum = 0;
          for (let i = 0; i < data.diff.length; i++) {
            const diffItem = data.diff[i];
            if (typeof diffItem === "string" && diffItem.includes("+")) {
              const parts = diffItem
                .split("+")
                .map((p) => parseFloat(p.trim()));
              if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
                totalDiffSum += parts[0] + parts[1];
              }
            } else {
              const num = parseFloat(diffItem);
              if (!isNaN(num)) totalDiffSum += num;
            }
          }

          labelPage.drawText(totalDiffSum.toFixed(1), {
            x: 630,
            y: diffRowY - 20,
            size: 12,
            font: boldFont,
          });
        });

        const pdfBytes = await pdfDoc.save();
        setPdfUrlCh(
          URL.createObjectURL(
            new Blob([pdfBytes], { type: "application/pdf" }),
          ),
        );
      } catch (error) {
        console.error("Error generating PDF:", error);
      }
    }
  }

  useEffect(() => {
    handleGeneratePDF();
  }, [batchHeaderData]);

  //   useEffect(() => {
  //     if (sessionStorage.getItem("logoImageUrl")) {
  //       handleGeneratePDF();
  //     }
  //   }, [sessionStorage.getItem("logoImageUrl")]);

  return (
    <Grid container spacing={2} alignItems='center'>
      <iframe
        src={pdfUrlCh}
        width='100%'
        height='600px'
        title='Batch Report PDF'
      />
    </Grid>
  );
};

export default BatchReport;
